/**
 * Fast Animations (Options): this screen's game animations run faster (dice landing, war and
 * ghost roll reveals, the five of a kind splash, the pause before someone else's attack). Only
 * this player's screen changes: the server paces bots for the normal speed either way.
 */

/** Fast Animations runs every timed animation at this fraction of its normal length (about 3x faster). */
const FAST_SCALE = 0.35;

let fast = false;

/** Set from the player's options (see `useOptions`). */
export function setFastAnimations(on: boolean): void {
  fast = on;
}

/** An animation length (ms) as this player sees it: shorter with Fast Animations on. */
export const anim = (ms: number): number => (fast ? Math.round(ms * FAST_SCALE) : ms);
